module.exports = __webpack_public_path__ + "img/list-item.5acbc3c6.svg";